export const SET_ASSET_PAGE_BACK_LINK = 'Dyzio/AnalyticsAsset/SET_ASSET_PAGE_BACK_LINK';



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset/constants.js
 **/